import {
    CONTRACT_NOTES_CLIENT_PREFERENCES,
    type CommunicationPreferences,
    type ContractNotesClientPreference,
} from '@/account/type'

type ParticipantContractNoteFields = {
    contractNotePreference: Exclude<
        ContractNotesClientPreference,
        (typeof CONTRACT_NOTES_CLIENT_PREFERENCES)['CUSTOM_EMAIL']
    >
}

export function buildCommunicationPreferences(participant: ParticipantContractNoteFields): CommunicationPreferences {
    const { contractNotePreference } = participant
    return {
        contractNotes: {
            preference: contractNotePreference,
        },
    }
}
